import DOMPurify from "dompurify";
import { styled } from "@mui/material";

const StyledPre = styled("pre")`
  white-space: pre-line;
  margin-bottom: 1em;
  padding: 1em;
  border: 1px solid #ddd;
  float: left;
  border-radius: 1px;
  width: 100%;
  font-size: 0.875em;
  line-height: 1.25;
  height: 100%;
  display: flex;
  overflow: auto;
`;

const HTMLTextContainer = ({ content }: { content: string }) => {
  return (
    /*
        The reason we can't just do `<pre>{props.content}</pre>`
        is that Safari injects links to make (apparent) telephone numbers
        clickable. These links will be escaped by React so the literal html is visible.
        By setting the innerHTML ourselves the links get injected (and we can disable them via CSS).
        The solution to add `<meta name="format-detection" content="telephone=no">` doesn't work.
    */
    <StyledPre
      translate="no"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content, {
          USE_PROFILES: { html: false },
        }),
      }}
    />
  );
};

export default HTMLTextContainer;
